import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import TipoBeneficioService from '../../app/service/TipoBeneficioService'

class TipoBeneficio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: null,
      tipos: [],
      codigo: '',
      nome: '',
      modalTipo: false,
      modalTipoAlterar: false,
      openSpinner: false,
    }

    this.tipoBeneficioService = new TipoBeneficioService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);

  }

  listarTipos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tipoBeneficioService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Benefícios', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({tipo: null});
    this.setState({nome: ''});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTipo(rowData)}
                tooltip="Editar Tipo de Benefício" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Tipo de Benefício" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(tipo) {
    this.setState({codigo: tipo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Tipo de Benefício?',
        header: 'Exclusão de Motivo do Resultado',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  accept() {
    this.excluirTipo();
  }

  excluirTipo = async () => {
    this.setState({openSpinner: true});
    await this.tipoBeneficioService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Benefício', detail:'Tipo de Benefício excluído com sucesso', life: 4000});
        this.listarTipos();
      });
      this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  async consultarTipo(tipo){
    this.setState({openSpinner: true});
    this.tipoBeneficioService.consultar(tipo.codigo)
      .then(response => {
        this.setState({tipo: response.data});
        this.setState({nome: response.data.nome});
        this.setState({codigo: response.data.codigo});
        this.abrirModaAlterar('modalTipoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Benefício', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarTipo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Benefício', detail:'Nome do Tipo de Benefício é obrigatório', life: 4000});
      return;
    }
    const tipo = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.tipoBeneficioService.cadastrar(tipo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Benefício', detail:'Tipo e Benefício cadastrado com sucesso', life: 4000});
        this.fecharModal('modalTipo');
        this.listarTipos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Benefício', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarTipo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Benefício', detail:'Nome do Tipo de Benefício é obrigatório', life: 4000});
      return;
    }

    const tipo = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.tipoBeneficioService.alterar(tipo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Benefício', detail:'Tipo de Benefício alterado com sucesso', life: 4000});
        this.fecharModal('modalTipoAlterar');
        this.listarTipos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Benefício', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarTipos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Motivos */}
          <Dialog header="Cadastro de Tipo de Benefício"
                    visible={this.state.modalTipo} 
                    style={{ width: '40vw' }} 
                    footer={
                      <div>
                          <Button label="Cadastrar" 
                                  className="p-button-primary p-button-text"
                                  onClick={this.cadastrarTipo}/> 
                          &nbsp;
                          <Button label="Cancelar" 
                                className="p-button-secondary p-button-text"
                                onClick={() => this.fecharModal('modalTipo')}/>
                      </div>
                    } 
                    onHide={() => this.fecharModal('modalTipo')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipo">Nome</label>
                        <InputText id="nomeTipo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Motivos */}
          <Dialog header="Alterar Tipo de Benefício"
                    visible={this.state.modalTipoAlterar} 
                    style={{ width: '40vw' }} 
                    footer={
                      <div>
                          <Button label="Alterar" 
                                  className="p-button-primary p-button-text"
                                  onClick={this.alterarTipo}/> 
                          &nbsp;
                          <Button label="Cancelar" 
                                className="p-button-secondary p-button-text"
                                onClick={() => this.fecharModal('modalTipoAlterar')}/>
                      </div>
                    } 
                    onHide={() => this.fecharModal('modalTipoAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipoAlterar">Nome</label>
                        <InputText id="nomeTipoAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-wallet"></i>
                        <span> Tipos de Benefício</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalTipo')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.tipos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks 
                      NextPageLink LastPageLink RowsPerPageDropdown"
                      size="small"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage=" " rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

TipoBeneficio.contextType = AuthContext;
export default withRouter (TipoBeneficio)